// src/components/Layout.js
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ConsentModal from './ConsentModal';
import { useAuth } from '../contexts/AuthContext';
import apiClient from '../api/axios';

const Layout = ({ children }) => {
    const { user, isAuthenticated, updateUser } = useAuth();
    const location = useLocation();
    const [showConsentModal, setShowConsentModal] = useState(false);

    useEffect(() => {
        // Не показываем модальное окно согласия на странице политики
        if (location.pathname === '/privacy') {
            setShowConsentModal(false);
            return;
        }
        // Проверяем, было ли уже показано и закрыто модальное окно в этой сессии
        const consentHandled = sessionStorage.getItem('consentModalHandled');
        if (isAuthenticated && user && !user.consent_to_data_processing && !consentHandled) {
            setShowConsentModal(true);
        }
    }, [isAuthenticated, user, location.pathname]);

    const handleConsentGiven = async () => {
        setShowConsentModal(false);
        // Помечаем, что модальное окно было обработано
        sessionStorage.setItem('consentModalHandled', 'true');
        // Обновляем данные пользователя в контексте
        try {
            const response = await apiClient.get('/users/me');
            updateUser(response.data);
        } catch (err) {
            console.error('Error refreshing user data:', err);
        }
    };

    return (
        <div className="d-flex flex-column min-vh-100">
            <Navbar />
            <div className="container mt-4 flex-grow-1">
                {children}
            </div>
            <ToastContainer position="bottom-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <Footer isAuthenticated={!!user} />
            <ConsentModal 
                show={showConsentModal} 
                onClose={() => setShowConsentModal(false)} 
                onConsentGiven={handleConsentGiven}
                userId={user?.id}
            />
        </div>
    );
};

export default Layout;